import React from "react";

interface SettingsCardProps {
  children: React.ReactNode;
  title?: string;
  subtitle?: string;
}

const SettingsCard: React.FC<SettingsCardProps> = ({ children, title, subtitle }) => {
  return (
    <div className="p-4 border border-[#E6E9EF] border-solid rounded-md">
      {title && <SettingsCardTitle title={title} subtitle={subtitle} />}
      {children}
    </div>
  );
};

export default SettingsCard;

function SettingsCardTitle({ title, subtitle }: { title?: string; subtitle?: string }) {
  return (
    <div className="mb-4 space-y-2">
      <h3 className="font-medium">{title}</h3>
      {subtitle && <p className="text-sm text-light-secondary-text-color">{subtitle}</p>}
    </div>
  );
}
